/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_Location_PersonalInputs */



/**
* | output |
* | --- |
* | "Personal" |
*
* @param {Explorer_Search_Location_PersonalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_location_personal = /** @type {((inputs?: Explorer_Search_Location_PersonalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Location_PersonalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Personal")
	if (locale === "de") return /** @type {LocalizedString} */ ("Personal")
	if (locale === "it") return /** @type {LocalizedString} */ ("Personal")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Personal")
	if (locale === "es") return /** @type {LocalizedString} */ ("Personal")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Personal")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Personal")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Personal")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Personal")
	return /** @type {LocalizedString} */ ("Personal")
});